import {
    UPDATE_CAMPAIGN,
    UPDATE_CAMPAIGN_FAILURE,
    UPDATE_CAMPAIGN_SUCCESS,
} from 'store/actions/types';

// Update Point of Interest
export const updateCampaign = (payload) => {
    return {
        type: UPDATE_CAMPAIGN,
        payload: payload,
    };
};

export const updateCampaignFailure = (error) => {
    return {
        type: UPDATE_CAMPAIGN_FAILURE,
        error: error,
    };
};

export const updateCampaignSuccess = (payload, response) => {
    return {
        type: UPDATE_CAMPAIGN_SUCCESS,
        id: response.id,
        response: response,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/campaigns/updateCampaigns.js